module.exports = __webpack_public_path__ + "static/img/step1.12330bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessFlow/step1.png
// module id = bYdy
// module chunks = 1